import {
    GetInvites,
    PostInviteInput,
    PostInviteResponse,
} from "../../types/api/invite";
import { request } from "../apiService";
import axios from "axios";
import { getAccessToken } from "../../utils/jwt";
import { GetInviteLinkResponse } from "../../types/api/invite";

export const getInvites = async () => {
    return await request<GetInvites>("/v2/invite");
};

export const inviteUser = async (email: string) => {
    return await request<PostInviteResponse, PostInviteInput>("/v2/invite", {
        method: "POST",
        input: { email },
    });
};

export const resendInvite = async (email: string) => {
    const token = getAccessToken();
    return await axios.post(
        `${process.env.REACT_APP_JT_API}/v2/invite/resend`,
        { email },
        {
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        }
    );
};

export const cancelInvite = async (email: string) => {
    const token = getAccessToken();
    return await axios.post(
        `${process.env.REACT_APP_JT_API}/v2/invite/cancel`,
        { email },
        {
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        }
    );
};

export const getInviteLink = async (
    email: string
): Promise<GetInviteLinkResponse> => {
    const token = getAccessToken();
    const res = await axios.get(
        `${process.env.REACT_APP_JT_API}/v2/invite/link`,
        {
            params: { email },
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        }
    );

    return res.data as GetInviteLinkResponse;
};

export const verifyInvite = async (token: string) => {
    await request<void, { token: string }>("/v2/invite/verify", {
        method: "POST",
        input: { token },
        skipAuth: true,
    });
    return true;
};
